import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as api from '../../api/api'
import * as actions from '../../actions'
import TPOUpdateModal from './TPOUpdateModal'
import { ListDivider } from 'rmwc/List';
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import {
  Dialog,
  DefaultDialogTemplate,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
  DialogBackdrop
} from 'rmwc/Dialog';

import {TextField} from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import { Select } from 'rmwc/Select';

import SerializeForm from 'form-serialize'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';

import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';

import ReactExport from "react-data-export";

import StatusMessage from '../../util/StatusMessage'


class TPORegisteredUsers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: '',
      message: '',
      open: false,
      snackbarIsOpen: false,
      showUpdateModal: false,
      selectedTPO: '',
      loading:false,
      partialDownloadDisable: true,
      downloadDisable: true,
      selectedUser: {
        user_id: '',
        email:'',
        amount:'',
        status:'',
        email:''
      },
      data: {
        certification:'TPO',
        registeredUsers:[],
        message:'',
        page: 1,
        totalPages: '',
        criteria: 'user_name',
        searchTerm: '',
        exportData:[],
        partialExportData:[],
        exportPage: 1,
        testCycles: [],
        testCycle: ''
      }
    }
    this.handleInvoice = this.handleInvoice.bind(this)
    
  }


  componentDidMount() {
    
    let data = Object.assign({}, this.state.data)
    let url = `test_cycle/all/3`

    console.log('Inside component did mount before calling api')
    api.getUserResponse(this.props.user.accessToken, url).then((result) => {
        if (result.status === 'success') {
          data.testCycles = result.data
          this.setState({data:data, loading:false})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details', loading:false })
      })

  }


  fetchRegisteredUsers =() =>{

    let data = Object.assign({}, this.state.data)
    this.setState({loading:true})
    api.getRegisteredUsers(this.props.user.accessToken, data.certification, data.testCycle, data.page).then((result) => {
        data.searchTerm = ''

        const { status, errors} = result
        if (status === 'error') {
          this.setState({ errorMsg: 'Error in Fetching Detail', loading:false })  
        }
        if (status === 'success') {
          
          data.registeredUsers = result.data.tpo_certifications
          data.totalPages = result.no_of_pages
          this.setState({data:data, loading:false})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching Details', loading:false })
      })
  }



  handleNotify = (e, selectedUserParam) => {
    let selectedUser = Object.assign({}, this.state.selectedUser)
    selectedUser.user_id = selectedUserParam.user_id
    selectedUser.amount = selectedUserParam.amount
    selectedUser.email = selectedUserParam.email
    selectedUser.status = selectedUserParam.status
    selectedUser.name = selectedUserParam.user_name
    
    this.setState({selectedUser: selectedUser, open: true, snackbarIsOpen: false})
    
  }

  handleCycleChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data.testCycle = e.target.value
    this.setState({data: data})
  }

  handleSearchCriteriaChange = (e) => {
    let data = Object.assign({}, this.state.data)
    data.criteria = e.target.value
    this.setState({data: data})
  }


  handleSearch = (e) => {
    //console.log("Inside fetch")
    //console.log("search term - " + this.state.data.searchTerm)
    e.preventDefault()
    if(this.state.data.searchTerm === ''){
      //console.log("inside NO Search")
      this.fetchRegisteredUsers()
    }
    else{
      //console.log("Inside search fetch before call")
      this.fetchSearchResults(this.state.data.page)
    }
  }


  fetchSearchResults = (pageParam) =>{

    let data = Object.assign({}, this.state.data)
    
     let apiInput = {
          'type': data.certification,
          'test_cycle_id': data.testCycle,
          'criteria': data.criteria,
          'term': data.searchTerm,
          'page': pageParam
      }
    this.setState({loading:true})
    api.searchRegistrations(this.props.user.accessToken, apiInput).then((result) => {
          const { status, errors} = result
          data.page = pageParam
          data.loading = false
          if (status === 'error') {
            this.setState({ errorMsg: 'Invalid Search Criteria', loading:false }) 
            data.registeredUsers =[]
            data.totalPages = 0
          }
          if (status === 'success') {
            
            data.registeredUsers = result.data.tpo_certifications
            data.totalPages = result.no_of_pages
            
          }
          this.setState({data:data, loading:false})
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', loading:false })
      })
  } 

  handleSearchQuery = (e) => {

    e.preventDefault()
    this.fetchSearchResults(1)
    
  }

  handleClear = (e) => {
    e.preventDefault()
    const data = Object.assign({}, this.state.data);
    data.searchTerm =''
    this.setState({data:data})
    this.fetchSearchResults(1)
    
  }

  /** Was used initially, Now moved to page display with handleUpdateTPO method 
  handleshowUpdateModal = (e, tpoCertId) => {
    this.setState({ showUpdateModal: true, selectedTPO: tpoCertId })
  }

  */
  
  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onUpdateModalClose = () => {
    
    this.setState({ showUpdateModal: false })
  };

  
  handleUpdateTPO = (e, cert_part_id_param) => {
    e.preventDefault();
    let cert_part_id = cert_part_id_param
    this.props.history.push(`/portal/app/tpo_registration_update/${cert_part_id}`)

  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

   handleSendMessage = e => {
    e.preventDefault()
    let apiInput = {
      'email': this.state.selectedUser.email,
      'message': this.state.data.message    
    }

    api.notifyRegisteredUsers(this.props.user.accessToken,apiInput)
    .then((result) => {
      if(result.errors){
        this.setState({ errorMsg: result.errors })
      }
      else{
        this.setState({ errorMsg: '' ,
                        snackbarIsOpen: !this.state.snackbarIsOpen,
                        open: false,
                        })
      }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }

    handleExportData = e => {
      e.preventDefault()
     let data = Object.assign({}, this.state.data)
     if(!this.state.downloadDisable){
        this.setState({downloadDisable: true})
      }
     api.exportTPORegData(this.props.user.accessToken, data.testCycle, data.exportPage).then((result) => {
        const { status, errors} = result
          if (status === 'success') {
            data.exportData = result.data
            this.setState({data:data, downloadDisable: false})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', downloadDisable: true })
        })
    }

    handlePartialExportData = e => {
      e.preventDefault()
      if(!this.state.partialDownloadDisable){
        this.setState({partialDownloadDisable: true})
      }
     let data = Object.assign({}, this.state.data)
     api.partialExportTPORegData(this.props.user.accessToken, data.testCycle).then((result) => {
        const { status, errors} = result
          if (status === 'success') {
            data.partialExportData = result.data
            this.setState({data:data, partialDownloadDisable: false})
          }
        })
        .catch((err) => {
          this.setState({ errorMsg: 'Error in Fetching Details', partialDownloadDisable: true })
        })
    }

    handleInvoice = (e, paymentId) => {

    e.preventDefault()
    let payId = paymentId + ".pdf" 

    api.downloadTPOInvoice(this.props.user.accessToken, payId)
      .then((result) => {
        if (result instanceof Blob) {
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({errorMsg: 'Unable to download invoice. Please contact Administrator' })
          
        }  
    })

  }

  render() {
    const { open } = this.state;
    const {registeredUser} = this.state;
     let userListCompnent
     let handleNotify = this.handleNotify
     let handleUpdateTPO = this.handleUpdateTPO
     let openModal = this.openModal
     let handleInvoice= this.handleInvoice
     
     if(this.state.data.registeredUsers.length >0){
      userListCompnent = 
        ( <tbody>
            {this.state.data.registeredUsers.map(regUser => (

              <tr>
                <td>{regUser.user_id}</td>
                <td>{regUser.user_name}</td>
                <td>{regUser.first_name}</td>
                <td>{regUser.last_name}</td>
                <td>{regUser.email}</td>
                <td>{regUser.phone}</td>
                <td><Button onClick={((e) => handleUpdateTPO(e, regUser.cert_part_id))}>Update</Button></td>
                <td><a href="" onClick={((e) => handleInvoice(e, regUser.payment_id))}>Invoice</a></td>
                <td>{regUser.cert_part_id}</td>
                <td>{regUser.id}</td>
                <td>{regUser.test_center}</td>
                <td>{regUser.location_one}</td>
                <td>{regUser.location_two}</td>
                <td>{regUser.test_track1}</td>
                <td>{regUser.time_slot1}</td>
                <td>{regUser.test_track2}</td>
                <td>{regUser.time_slot2}</td>
                <td>{regUser.test_track3}</td>
                <td>{regUser.time_slot3}</td>
                <td>{regUser.amount}</td>
                <td>{regUser.amount_paid}</td>
                <td>{regUser.status}</td>
                <td>{regUser.roll_number1}</td>
                <td>{regUser.national_rank1}</td>
                <td>{regUser.regional_rank1}</td>
                <td>{regUser.city_rank1}</td>
                <td>{regUser.subject_rank1}</td>
                <td>{regUser.roll_number2}</td>
                <td>{regUser.national_rank2}</td>
                <td>{regUser.regional_rank2}</td>
                <td>{regUser.city_rank2}</td>
                <td>{regUser.subject_rank2}</td>
                <td>{regUser.roll_number3}</td>
                <td>{regUser.national_rank3}</td>
                <td>{regUser.regional_rank3}</td>
                <td>{regUser.city_rank3}</td>
                <td>{regUser.subject_rank3}</td>
                <td>{regUser.created_at}</td>
                <td>{regUser.working_organization}</td>
                <td>{regUser.hear_about}</td>
                <td>{regUser.referral_code}</td>
                <td>{regUser.payment_id}</td>
                <td>{regUser.state}</td>
                <td><Button onClick={((e) => handleNotify(e, regUser))}>Notify</Button></td>
              </tr>
            ))}
          </tbody>  
        )

     }


     let Snackbarcomponent =(
          <Snackbar
            show={this.state.snackbarIsOpen}
            onHide={evt => this.setState({snackbarIsOpen: false})}
            message="Notification email sent to user with the access link"
      />
      )

     let notiticaionModal=(
      <Dialog
        open={open}
         onClose={evt => this.setState({open: false})}
      >
        <DialogSurface>
        <DialogHeader>
          <DialogHeaderTitle>Message Compose</DialogHeaderTitle>
        </DialogHeader>
        <DialogBody>
          <h5> To: {this.state.selectedUser.email} </h5>
          <TextField 
            textarea 
            fullwidth
            label="Message" 
            autoComplete="off" 
            name="message" 
            value={this.state.data.message} 
            onChange={this.onInputChange}
          />
        </DialogBody>
        <DialogFooter>
            <DialogFooterButton cancel>Cancel</DialogFooterButton>
            <DialogFooterButton onClick={((e) => this.handleSendMessage(e))}>Send</DialogFooterButton>
        </DialogFooter>
        </DialogSurface>
        <DialogBackdrop />  
      </Dialog>
    )

    let paginationComponent = (

                <div>
                  <TextField  className='text_input' label="Page Number" autoComplete="off" name="page" onChange={this.onInputChange} value={this.state.data.page}/>
                  <Button  onClick={this.handleSearch}>
                    Fetch
                  </Button>
                  <Select 
                    onChange={this.handleSearchCriteriaChange} 
                    value={this.state.data.criteria}
                    className="admin-reg-filter-section" 
                  >
                    <option value="user_name">User Name</option>
                    <option value="email">Email</option>
                    <option value="phone">Number</option>
                    <option value="test_center">Test Center</option>
                    <option value="organization">Organization</option>
                    
                  </Select>
                  <TextField  className='admin-reg-filter-criteria' label="Search Term" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.data.searchTerm}/>
                  <Button className="add-opportunity" onClick={this.handleSearchQuery}>
                    Search
                  </Button>
                  <Button className="add-opportunity" onClick={this.handleClear}>
                    Clear
                  </Button>
              <br/><br/>
                </div>
              
           
        )

    let updateModal = ''
    if (this.state.showUpdateModal) {
      
      updateModal = (
        <TPOUpdateModal
          onClose={this.onUpdateModalClose}
          updateOpen = {this.state.showUpdateModal}
          selectedTPO = {this.state.selectedTPO}
        />
      )
    }

      let ExcelFile = ReactExport.ExcelFile;
      let ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      let  ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

      let exportComponent =(
         <div>
              <TextField  className='text_input' label="Export Page" autoComplete="off" name="exportPage" onChange={this.onInputChange} value={this.state.data.exportPage}/>
              <Button onClick={this.handleExportData}>Export</Button>
              <ExcelFile element={<Button disabled={this.state.downloadDisable}>Download</Button>}>
                <ExcelSheet data={this.state.data.exportData} name="tpo">
                    <ExcelColumn label="user_name" value="user_name"/>
                    <ExcelColumn label="user_id" value="user_id"/>
                    <ExcelColumn label="email" value="email"/>
                    <ExcelColumn label="phone" value="phone"/>
                    <ExcelColumn label="first_name" value="first_name"/>
                    <ExcelColumn label="last_name" value="last_name"/>
                    <ExcelColumn label="tpo_id" value="tpocertid"/>
                    <ExcelColumn label="certification_participation_id" value="cert_part_id"/>
                    <ExcelColumn label="testcenter" value="testcenter"/>
                    <ExcelColumn label="tpo_test_track_1" value="tpo_test_track_1"/>
                    <ExcelColumn label="time_slot_1" value="time_slot_1"/>
                    <ExcelColumn label="tpo_test_track_2" value="tpo_test_track_2"/>
                    <ExcelColumn label="time_slot_2" value="time_slot_2"/>
                    <ExcelColumn label="tpo_test_track_3" value="tpo_test_track_3"/>
                    <ExcelColumn label="time_slot_3" value="time_slot_3"/>
                    <ExcelColumn label="amount" value="amount"/>
                    <ExcelColumn label="payment_id" value="payment_id"/>
                    <ExcelColumn label="payment_status" value="payment_status"/>
                    <ExcelColumn label="referral_code" value="referral_code"/>
                    <ExcelColumn label="location_pref_one" value="location_pref_one"/>
                    <ExcelColumn label="location_pref_two" value="location_pref_two"/>
                    <ExcelColumn label="teaching_association" value="teaching_association"/>
                    <ExcelColumn label="working_organization" value="working_organization"/>
                    <ExcelColumn label="tpo_reference" value="tpo_reference"/>
                    <ExcelColumn label="tpo_reference_sub" value="tpo_reference_sub"/>
                    <ExcelColumn label="created_at" value="created_at"/>
                </ExcelSheet>
              </ExcelFile>
            </div>

        )

      ExcelFile = ReactExport.ExcelFile;
      ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
      ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

      let partialExportComponent =(
         <div>
              <Button onClick={this.handlePartialExportData}>Export Partial</Button>
               <ExcelFile element={<Button disabled={this.state.partialDownloadDisable}>Download Partial</Button>}>
                <ExcelSheet data={this.state.data.partialExportData} name="partialtpo">
                    <ExcelColumn label="user_name" value="user_name"/>
                    <ExcelColumn label="user_id" value="user_id"/>
                    <ExcelColumn label="email" value="email"/>
                    <ExcelColumn label="phone" value="phone"/>
                    <ExcelColumn label="first_name" value="first_name"/>
                    <ExcelColumn label="last_name" value="last_name"/>
                    <ExcelColumn label="test_center_name" value="test_center_name"/>
                    <ExcelColumn label="working_organization" value="working_organization"/>
                    <ExcelColumn label="teaching_association_id" value="teaching_association_id"/>
                    <ExcelColumn label="created_at" value="created_at"/>
                    <ExcelColumn label="updated_at" value="updated_at"/>
                    <ExcelColumn label="test_cycle_id" value="test_cycle_id"/>
                    <ExcelColumn label="certification_participation_id" value="certification_participation_id"/>                    
                </ExcelSheet>
              </ExcelFile>
            </div>

        )

      let parentComponent
      if(this.state.loading){
        parentComponent = (
            <div className="loader-component">
              <div className="loader"></div>
              <h4> TPO Registration Detail is being fetched. Please wait</h4>
            </div>
          )
      }

      else{
        parentComponent = (

          <Grid>
            <GridCell span="12">
              <div>Registered Users
              
                
                <select 
                  label="certification"
                  onChange={this.handleChangeCertification} 
                  value={this.state.data.certification}
                  className="admin-reg-filter-criteria" 
                  hidden
                >
                  <option value="TPO">TPO</option>
                  
                </select>

                <label className="admin-reg-filter-section">Cycle:</label>
                
                <Select
                  name="test_cycle"
                  onChange={this.handleCycleChange} 
                  value={this.state.data.testCycle}
                  className="admin-reg-filter-criteria"
                  placeholder="-Test Cycle-"
                >
                  {this.state.data.testCycles.map(cycle => (
                    <option key={cycle.id} value={cycle.id} data-name={cycle.name}>
                      {cycle.name}
                    </option>
                  ))}
                </Select>

                <Button className="add-opportunity" onClick={this.handleSearch}>
                    Search
                </Button>
                <label className="admin-reg-filter-section"> Total Pages- {this.state.data.totalPages} </label>
              </div>
              {paginationComponent}

              {exportComponent}
              {partialExportComponent}

              <div>
                <table>
                  <th>User Id</th>
                  <th>User_Name</th>
                  <th>First_Name</th>
                  <th>Last_Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Update</th>
                  <th>Invoice</th>
                  <th>Certification Participation</th>
                  <th>TPO Id</th>
                  <th>Test City</th>
                  <th>Location I</th>
                  <th>Location II</th>
                  <th>TPO_TestTrack_One</th>
                  <th>Slot 1</th>
                  <th>TPO_Test_Track_Two</th>
                  <th>Slot 2</th>
                  <th>TPO_Test_Track_Three</th>
                  <th>Slot 3</th>
                  <th>Amount</th>
                  <th>Amount Paid</th>
                  <th>status</th>
                  <th>roll_number1</th>
                  <th>national_rank1</th>
                  <th>regional_rank1</th>
                  <th>city_rank1</th>
                  <th>subject_rank1</th>
                  <th>roll_number2</th>
                  <th>national_rank2</th>
                  <th>regional_rank2</th>
                  <th>city_rank2</th>
                  <th>subject_rank2</th>
                  <th>roll_number3</th>
                  <th>national_rank3</th>
                  <th>regional_rank3</th>
                  <th>city_rank3</th>
                  <th>subject_rank3</th>
                  <th>created_at</th>
                  <th>working_organization</th>
                  <th>hear_about</th>
                  <th>referral_code</th>
                  <th>payment_id</th>
                  <th>state</th>
                  <th>Action</th>
                  <th></th>
                  {userListCompnent}
                </table>
              </div>
              {notiticaionModal}
              {updateModal}
              
            </GridCell>
          </Grid>


          )
        }

      return (
        <div>
          {parentComponent}
        </div>
      )
    
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPORegisteredUsers);


// WEBPACK FOOTER //
// ./src/views/admin/TPORegisteredUsers.jsx